import { observable, makeObservable } from 'mobx';
import { AppState } from 'src/appState/AppState';
import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';

export class YouDecideState {
    public readonly appState: AppState;
    @observable public isConfirmationOpened: boolean = false;

    public constructor(appState: AppState) {
        makeObservable(this);
        this.appState = appState;
    }

    public onAddToBetslipInner = (): void => {
        AppSportsBookState.get(this.appState.common).rab.addToBetslip();

        this.isConfirmationOpened = true;

        setTimeout(() => {
            this.isConfirmationOpened = false;
        }, 3000);
    };
}
